import { CryptoRewardsPaneMode } from 'components/features/rewards/rewardsPane/types/paneState'
import { OrdersResultsReducer } from 'components/features/rewards/rewardsPane/types/store'
import { createAction } from 'helpers/actionHelpers/createAction'

type OrderResultsReducerChangeStateActionPayload = Partial<OrdersResultsReducer<CryptoRewardsPaneMode>>

export class OrderResultsReducerChangeStateAction extends (
  createAction<'ORDER_RESULTS_REDUCER_CHANGE_STATE', OrderResultsReducerChangeStateActionPayload>('ORDER_RESULTS_REDUCER_CHANGE_STATE')
) {}

type OrderResultsReducerChangeLastOrderActionPayload = Exclude<OrdersResultsReducer<CryptoRewardsPaneMode>['lastOrderResult'], undefined>

export class OrderResultsReducerChangeLastOrderAction extends (
  createAction<'ORDER_RESULTS_REDUCER_CHANGE_LAST_ORDER', OrderResultsReducerChangeLastOrderActionPayload>('ORDER_RESULTS_REDUCER_CHANGE_LAST_ORDER')
) {}

export class OrderResultsReducerResetLastOrderErrorsAction extends (
  createAction<'ORDER_RESULTS_REDUCER_RESET_LAST_ORDER_ERRORS', void>('ORDER_RESULTS_REDUCER_RESET_LAST_ORDER_ERRORS')
) {}

export class OrderResultsReducerNewOrderPendingAction extends (
  createAction<'ORDER_RESULTS_REDUCER_NEW_ORDER_PENDING', CryptoRewardsPaneMode>('ORDER_RESULTS_REDUCER_NEW_ORDER_PENDING')
) {}

export type OrderResultsReducerChangeLastPreviewOrderActionPayload = Exclude<OrdersResultsReducer<CryptoRewardsPaneMode>['lastOrderPreviewResult'], undefined>

export class OrderResultsReducerChangeLastPreviewOrderAction extends (
  createAction<'ORDER_RESULTS_REDUCER_CHANGE_LAST_PREVIEW_ORDER', OrderResultsReducerChangeLastPreviewOrderActionPayload>('ORDER_RESULTS_REDUCER_CHANGE_LAST_PREVIEW_ORDER')
) {}

export class OrderResultsReducerNewPreviewOrderPendingAction extends (
  createAction<'ORDER_RESULTS_REDUCER_NEW_PREVIEW_ORDER_PENDING', void>('ORDER_RESULTS_REDUCER_NEW_PREVIEW_ORDER_PENDING')
) {}

export class OrderResultsReducerResetLastPreviewOrderErrorsAction extends (
  createAction<'ORDER_RESULTS_REDUCER_CHANGE_LAST_PREVIEW_ORDER_RESET_ERRORS', void>('ORDER_RESULTS_REDUCER_CHANGE_LAST_PREVIEW_ORDER_RESET_ERRORS')
) {}

export type OrderResultsReducerActions =
  | OrderResultsReducerChangeStateAction
  | OrderResultsReducerChangeLastOrderAction
  | OrderResultsReducerChangeLastPreviewOrderAction
  | OrderResultsReducerResetLastOrderErrorsAction
  | OrderResultsReducerResetLastPreviewOrderErrorsAction
  | OrderResultsReducerNewOrderPendingAction
  | OrderResultsReducerNewPreviewOrderPendingAction
